import { render, staticRenderFns } from "./MEM971M01.vue?vue&type=template&id=4e934037&"
import script from "./MEM971M01.vue?vue&type=script&lang=js&"
export * from "./MEM971M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports